import { Router } from "../../../../routes/Router";
import { TRoutePath } from "../../../../routes/Routes";
import { KCardAlumnos } from "../../../../ui/ventana/AlumnosPanelV2";
import { KGruposCard } from "../../../../ui/ventana/GruposPanelV2";

export const createNavigatePanelAction = (
    prefixHash: TRoutePath,
    id: number | string,
    mode?: KCardAlumnos | KGruposCard
): (() => void) => {
    return () => {
        const modeParam = "All";
        const modeFinal = mode || modeParam;

        Router._DoHash(prefixHash, {
            mode: modeFinal,
            id,
        });
    };
};

export const createNavigateModuleAction = (moduleHash: TRoutePath): (() => void) => {
    return () => {
        Router._DoHash(moduleHash);
    };
};
